import React, { Component } from 'react'
import { connect } from 'react-redux'

import moment from 'moment'


import Modal from '../Shared/Modal'
import ModalHeader from '../Shared/ModalHeader'
import ModalButtonStrip from '../Shared/ModalButtonStrip'
import ModalBody from '../Shared/ModalBody'
import ModalFooter from '../Shared/ModalFooter'
import BoxButton from '../Layout/BoxButton'
import General from '../Documentos/Contrato'
//import DocumentosFirmados from '../Documentos/DocumentosFirmados'


import Cancelacion from '../Documentos/Cancelacion'


import {
    showHideModalSummary,
    cancelDocumento
} from '../../actions/documentos'

import {
    closeDocumento, showHideModalAddFirmas, renewContrato
} from '../../actions/contratoanual'

import {
    showModalConfirmarAccion
} from '../../actions/common'

import {
    isAllowedToViewComponent
} from '../../utils/helpers'

class ModalSummary extends Component {
	constructor(props) {
		super(props)

        let tabs = [
            { id: 0, caption: 'Documento', component: <General />, estado: 0 },
            { id: 1, caption: 'Cierre', component: <Cancelacion />, estado: 0 },

        ]

        
		this.state = {
			tabs: [...tabs],
			selected: 0,
            maximised: false
		}
	}

    handleCloseModal = () => {

        const modal = document.getElementById('modalSummary')
        modal.classList.remove('fadeIn')
        modal.classList.add('fadeOut')

        const modalDialog = document.querySelector(`#modalSummary .modal-dialog`)
        modalDialog.classList.remove('zoomIn')
        modalDialog.classList.add('zoomOut')

        this.setState({ maximised: false, selected: 0 })
        setTimeout(() => this.props.showHideModalSummary(false), 300)
    }

	selectTab = (e, tab) => {
		e.preventDefault()
		this.setState({ selected: tab })
    }
    


    cancel = () => {
        this.props.showModalConfirmarAccion(true, `¿Está seguro que desea cancelar este documento?`, () => { this.props.showModalConfirmarAccion(false); this.props.cancelDocumento()})
    } 
    
    

    renew = (result) => {
        if (result == 1)
            this.props.showModalConfirmarAccion(true, `¿Está seguro que desea renovar este contrato?`, () => { this.props.showModalConfirmarAccion(false); this.props.renewContrato(1)})
        else   
            this.props.showModalConfirmarAccion(true, `¿Está seguro que desea no renovar este contrato?`, () => { this.props.showModalConfirmarAccion(false); this.props.renewContrato(0)}) 
    }  




    render() {
		const { tabs, selected, maximised } = this.state
        const { modalSummary, enums, solicitud } = this.props
        
        if (!modalSummary.get('show')) {
            return null
        }

        const documento = modalSummary.get('data')
        const id = documento.get('id')
        const docs_en_espera = solicitud.get('documentos').filter(x => x.get('id') != id && x.get('tipo') == 5 && x.get('estado') == 13)
        const docs_en_proceso = solicitud.get('documentos').filter(x => x.get('id') != id && x.get('tipo') == 5 && x.get('estado') > 0 && x.get('estado') < 11)


        let enableBtn = true
        enableBtn = enableBtn && moment().isAfter(`${new Date().getFullYear()}-11-30`) 
        //enableBtn = enableBtn && moment().isAfter(`${new Date().getFullYear()}-02-03`) 
        enableBtn = enableBtn && docs_en_espera.count() == 0
        enableBtn = enableBtn && documento.get('estado') == 12
        enableBtn = enableBtn && docs_en_proceso.count() == 0

        const esResponsableCompras = isAllowedToViewComponent('responsable_compras', solicitud)

        return(
            <Modal id="modalSummary" show={ true } ZIndex={ 2000 } draggable={ !maximised }>
                <ModalHeader title={ <span style={{ fontWeight: (maximised) ? 'bold' : 'normal' }}>{`Documento: ${enums.documentos.tipos[modalSummary.getIn(['data', 'tipo'])].NOMBRE} ${enums.documentos.tipos[modalSummary.getIn(['data', 'tipo'])].PREFIJO}${modalSummary.getIn(['data', 'consecutivo'])}` }</span> } onClose={ e => this.handleCloseModal(e, "modalSummary") } />
                <ModalButtonStrip>
                    <BoxButton
                        name={ maximised ? 'compress' : 'arrows-alt' }
                        title={ maximised ? 'Minimizar' : "Maximizar" }
                        onClick={ e => this.setState({ maximised: !maximised }) }
                    />

                    {
                        (this.state.selected === 0 && enableBtn && esResponsableCompras) && (
                            <BoxButton
                                name="history"
                                title="Renovar contrato"
                                onClick={ e => this.renew(1) }
                                disabled={documento.get('estado') == 14}
                            />
                        )
                    }

                    {
                        (this.state.selected === 0 && esResponsableCompras) && (
                            <BoxButton
                                name="cloud-upload"
                                title="Cerrar solicitud"
                                onClick={ e => this.props.showHideModalAddFirmas(true, solicitud) }
                                disabled = { documento.get('estado') != 3 }
                            />
                        )
                    }


                    {
                        (this.state.selected === 1 && enableBtn && esResponsableCompras) && (
                            <BoxButton
                                name="hand-stop-o"
                                title="No renovar contrato"
                                onClick={ e => this.renew(0) }
                                disabled={documento.get('estado') == 14}
                            />
                        )
                    }                    


                    {
                        (this.state.selected === 1 && esResponsableCompras) && (
                            <BoxButton
                                name="ban"
                                title="Cancelar contrato"
                                onClick={ e => this.cancel() }
                                disabled={ documento.get('estado') == 0 || documento.get('estado') == 14 }
                            />
                        )
                    }



                </ModalButtonStrip>
                <ModalBody>
                    <div className={ this.state.maximised ? 'modal-100-100' : 'modal-80-70' }>
                        <div className="row" style={{ height: '100%', overflowX: 'hidden' }}>
                            <div className="col-md-12" style={{ height: '100%' }}>
                                <div className="nav-container">
                                    <div className="nav-tabs-section">
                                        <ul className="nav-tabs-tabs green">
                                            {
                                                tabs.filter(x => x.estado <= documento.get('estado')).map(x => {

                                                    if (((documento.get('estado') >= 3 && documento.get('estado') < 12) || docs_en_espera.count() > 0) && x.id == 1) return null

                                                    return (
                                                        <li key={ `li02[${x.id}]` } className={ selected === x.id ? 'active' : '' }>
                                                            <a onClick={ (e) => this.selectTab(e, x.id) }>{ x.caption }</a>
                                                        </li>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </div>
                                    <div className="nav-main-section">
                                        <div className="nav-main-section-scrollable">
                                            { tabs[selected].component }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                </ModalFooter>
            </Modal>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        modalSummary: state.documentos.get('modalSummary'),
        user: state.common.get('user'),
        enums: state.common.get('enums').toJS(),
        //documentos_solicitud: state.contratoanual.getIn(['solicitud', 'documentos'])
        solicitud: state.contratoanual.get('solicitud')
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        closeDocumento: () => dispatch(closeDocumento()),
        showHideModalSummary: (state) => dispatch(showHideModalSummary(state)),
        showHideModalAddFirmas: (show, solicitud) => dispatch(showHideModalAddFirmas(show, solicitud)),
        showModalConfirmarAccion: (show, message, action) => dispatch(showModalConfirmarAccion(show, message, action)),
        cancelDocumento: () => dispatch(cancelDocumento()),
        renewContrato: (result) => dispatch(renewContrato(result))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(ModalSummary)


// WEBPACK FOOTER //
// ./src/components/ContratoAnual/ModalSummaryDocumento.jsx